/* src/app/forms/produtos/mercadolivre/meli-edit-form/meli-edit-form.component.scss */
.data-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  position: relative;
}
.form-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 8px 16px;
  border-bottom: 1px solid var(--tem-border, #f0f0f0);
  flex-wrap: wrap;
}
.wizard-steps {
  flex: 1 1 420px;
  min-width: 280px;
}
.step-clickable {
  cursor: pointer;
}
.form-toolbar-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
.columns-select {
  width: 130px;
}
.step-content {
  flex: 1;
  overflow: auto;
  padding: 16px;
  position: relative;
}
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 8px 16px;
  align-items: start;
}
.form-grid-single {
  grid-template-columns: 1fr;
}
.form-grid-full {
  grid-column: 1/-1;
}
.field-action {
  cursor: pointer;
  margin-left: 4px;
  color: var(--tem-muted, rgba(0, 0, 0, 0.45));
}
.field-action:hover {
  color: var(--tem-deep, #1890ff);
}
.spacer {
  flex: 1;
}
.image-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 8px;
  max-height: 160px;
  overflow: auto;
}
.image-tags nz-tag {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.multi-alert {
  margin-bottom: 8px;
}
.multi-table-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: relative;
}
.atributo-garantia {
  position: relative;
  min-height: 100%;
}
.links {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  padding: 4px 10px;
  background: var(--tem-surface-2, rgba(0, 0, 0, 0.03));
  border-radius: 6px;
}
.switch-label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
}
.attrib-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 12px;
  align-items: stretch;
}
.attrib-card {
  display: flex;
  flex-direction: column;
  border: 1px solid var(--tem-border, #f0f0f0);
  border-radius: 8px;
  padding: 10px 12px;
  min-height: 130px;
  background: var(--tem-surface, #fff);
}
.attrib-card-required {
  border-color: var(--tem-danger, #ff4d4f);
}
.attrib-card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
}
.attrib-card-title {
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.attrib-card-warn {
  color: var(--tem-danger, #ff4d4f);
  flex-shrink: 0;
}
.attrib-card-hint {
  font-size: 11px;
  color: var(--tem-muted, rgba(0, 0, 0, 0.45));
  min-height: 28px;
  max-height: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 6px;
}
.attrib-card-content {
  margin-top: auto;
}
.multi-field {
  display: flex;
  flex-direction: row;
  gap: 4px;
}
.multi-field .left {
  flex: 1 1 65%;
}
.multi-field .right {
  flex: 1 1 35%;
  min-width: 90px;
}
.full {
  width: 100%;
}
.main-variacao {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  overflow: auto;
}
.field-vert {
  display: flex;
  padding-right: 16px;
  flex-direction: column;
  gap: 12px;
  border-right: 1px solid var(--tem-border, #f0f0f0);
  justify-content: center;
}
.variacao-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  overflow: auto;
  padding: 10px;
  position: relative;
  margin-left: 16px;
  border-radius: 6px;
  border: 1px solid var(--tem-border, #f0f0f0);
}
.suspended-menu {
  position: absolute;
  display: flex;
  flex-direction: column;
  max-height: 300px;
  border: 1px solid var(--tem-border, rgba(0, 0, 0, 0.1215686275));
  overflow: auto;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  right: 16px;
  top: 60px;
  z-index: 100;
  background: var(--tem-surface, #fff);
}
.suspended-menu-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 220px;
  background-color: var(--tem-deep, #1890ff);
  color: #fff;
  cursor: move;
  font-size: 11px;
  padding: 8px 10px;
  gap: 6px;
}
.suspended-menu-actions-in {
  cursor: pointer;
  line-height: 1;
}
.suspended-menu-list {
  min-height: 40px;
  overflow: hidden;
  display: block;
}
.suspended-menu-box {
  padding: 5px 10px;
  border-bottom: solid 1px var(--tem-border, #eee);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  font-size: 11px;
}
.suspended-menu-box:last-child {
  border-bottom: none;
}
.cdk-drag-preview {
  box-sizing: border-box;
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.cdk-drag-placeholder {
  opacity: 0;
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
/*# sourceMappingURL=meli-edit-form.component.css.map */
